import React from 'react';
import { Box } from '@mui/material';

export const BRAND_NAME = 'ALEgION';
export const BRAND_NAME_MARKED = 'ALEgION®';

/**
 * Brand wordmark with registered mark superscripted above the N.
 * Use in JSX headings, eyebrows, and body copy.
 */
const BrandName = ({
  sx = {},
  registeredFontSize = '0.72em',
  component = 'span',
}) => (
  <Box
    component={component}
    sx={{
      display: 'inline',
      whiteSpace: 'nowrap',
      ...sx,
    }}
  >
    ALEgION
    <Box
      component="sup"
      aria-label="registered"
      sx={{
        fontSize: registeredFontSize,
        ml: '0.12em',
        top: '-0.45em',
        position: 'relative',
        fontWeight: 700,
        letterSpacing: 0,
        lineHeight: 0,
        fontFamily: '"DM Sans", "Inter", sans-serif',
      }}
    >
      ®
    </Box>
  </Box>
);

/**
 * Split a string on ALEgION / ALEgION® and wrap each brand mention in <BrandName />.
 */
export const withBrand = (text) => {
  if (text == null || text === '') return text;
  if (typeof text !== 'string') return text;

  const parts = text.split(/(ALEgION®?)/g);
  if (parts.length === 1) return text;

  return parts.map((part, i) => {
    if (part === 'ALEgION' || part === 'ALEgION®') {
      return <BrandName key={`brand-${i}`} />;
    }
    return part;
  });
};

/** Plain-string helper for attributes, downloads, aria labels */
export const brandText = (text) => {
  if (!text || typeof text !== 'string') return text;
  return text.replace(/ALEgION(?!®)/g, 'ALEgION®');
};

export default BrandName;
